const h = {
  name: "Chip2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,4V0h2v4h4V0h2v4h4V0h2v4h4v2H9V4H13z"/>
		<path class="st0" d="M27,13H13v14h14V13z M15,25V15h10v10H15z"/>
		<path class="st0" d="M31,9H9v22h22V9z M11,29V11h18v18H11z"/>
		<path class="st0" d="M27,36v4h-2v-4h-4v4h-2v-4h-4v4h-2v-4H9v-2h22v2H27z"/>
		<path class="st0" d="M4,27H0v-2h4v-4H0v-2h4v-4H0v-2h4V9h2v22H4V27z"/>
		<path class="st0" d="M36,13h4v2h-4v4h4v2h-4v4h4v2h-4v4h-2V9h2V13z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Chip2
};
